// extracted by mini-css-extract-plugin
module.exports = {"label":"TextInput_label__tC6LN","input":"TextInput_input__ouAF8"};